<template>
    <div class="login-container" v-if="isBrowser">
        <nuxt-link :to="localePath('/')">
            <div class="logo-img"></div>
        </nuxt-link>
        <h2>{{ $t('register') }}</h2>

        <div class="login-inner-container" v-if="!nextStep">
            <v-flex>
                <span class="login-label">{{ $t('myprofile1') }} *</span>
                <v-text-field
                    id="regFName"
                    ref="regFName"
                    v-model="regFName"
                    class="email-input"
                    :rules="[rules.required]"
                    :error="$v.regFName.$error"
                ></v-text-field>
            </v-flex>
            <v-flex>
                <span class="login-label">{{ $t('myprofile2') }} *</span>
                <v-text-field
                    v-model="regLName"
                    class="email-input"
                    :rules="[rules.required]"
                    :error="$v.regLName.$error"
                ></v-text-field>
            </v-flex>
            <v-flex>
                <span class="login-label">Email *</span>
                <v-text-field
                    ref="email"
                    v-model="regEmail"
                    class="email-input"
                    :rules="[rules.required, rules.emailValid]"
                ></v-text-field>
            </v-flex>
            <v-flex>
                <span class="login-label">{{ $t('password') }} *</span>
                <v-text-field
                    ref="regPassword"
                    v-model="regPassword"
                    :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="secureRegPassword ? 'password' : 'text'"
                    name="input-10-1"
                    hint="At least 8 characters"
                    counter
                    @click:append="secureRegPassword = !secureRegPassword"
                    v-on:keyup.enter="registration"
                >
                </v-text-field>
            </v-flex>
            <v-checkbox
                v-model="checked18"
                :label="$t('register-confirm18')"
            ></v-checkbox>
            <v-checkbox
                v-model="checkedTerms"
                class="check-terms"
            >
                <div slot="label">
                    {{ $t('register-terms') }}
                </div>
            </v-checkbox>
            <v-checkbox
                v-model="checkedNews"
                :label="$t('register-news')"
                class="check-terms"
            ></v-checkbox>
            <v-flex>
                <div class="errors-container2" v-if="errorMsg !== ''">
                    <p>{{ errorMsg }}</p>
                </div>
            </v-flex>
            <v-flex>
                <v-btn class="submit login-submit" v-on:click="registration">{{
                        $t('register-create')
                    }}
                </v-btn>
            </v-flex>
            <v-flex>
                <div class="social-title">
                    <span>{{ $t('register-or') }}</span>
                    <div class="social-border"></div>
                </div>
                <div class="social-btns-wrapper">
                    <v-facebook-login app-id="4547708611999159" @login="loginFb" @sdk-init="handleSdkInit">
                        <button slot="login">Sign up with Facebook</button>
                    </v-facebook-login>
<!--                    <GoogleLogin :params="params" :renderParams="renderParams" :onSuccess="loginGgl" :onCurrentUser="loggedGgl"></GoogleLogin>-->
                    <vue-apple-signin v-if="appleLoaded" color="black" :border="true" type="sign in"></vue-apple-signin>
                </div>
            </v-flex>

        </div>
        <div class="login-inner-container" v-else>
            <div class="login-success">
                <h2>Success!</h2>
                <div class="additional-info">
                    Check your email for an account activation link!
                </div>
            </div>

            <div class="login-success-btn-wrapper">
                <v-btn class="btn-primary btn-bid-proceed" v-on:click="goToLogin">OK</v-btn>
                <v-btn class="btn-bid-cancel" v-on:click="resendMail">{{ $t('activate-account5') }}</v-btn>
            </div>
        </div>

        <div class="footer-links">
            <div class="footer-link">
                <div class="forgot-pass">
                    <nuxt-link :to="localePath('/forgot-password')">{{ $t('register-forgot-pass') }}</nuxt-link>
                    <div class="link-border"></div>
                </div>
            </div>
            <div class="footer-link text-center">
                <div class="terms">
                    <nuxt-link :to="localePath('/terms-and-conditions')">{{ $t('footer22') }}</nuxt-link>
                    <div class="link-border"></div>
                </div>
            </div>
            <div class="footer-link text-right">
                <div class="create-account">
                    <nuxt-link :to="localePath('/login')">{{ $t('login') }}</nuxt-link>
                    <div class="link-border"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required, email, minLength} from 'vuelidate/lib/validators';
import {mapActions, mapGetters} from 'vuex';
import {AAuth, AUser} from '@/store/actions';
import {GUser} from "@/store/getters";
import {MAuth} from "@/store/mutations";

export default {
    name: 'Register',
    components: {
        VFacebookLogin: () => process.client ? import('vue-facebook-login-component') : null
    },
    props: {
        navigation: {
            type: Object
        }
    },
    head: {
        title: 'Registration | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        script: [
            {
                src: "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"
            }
        ]
    },
    validations: {
        regFName: {
            required
        },
        regLName: {
            required
        },
        regEmail: {
            required,
            email
        },
        regPassword: {
            required,
            minLength: minLength(8)
        }
    },
    computed: {
        ...mapGetters({
            visitorCountry: GUser.GET_VISITOR_COUNTRY
        }),
    },
    data() {
        return {
            params: {
                client_id: "374038783935-pibb3r2f1vnthclrgb4cqr5tv59ckl2m.apps.googleusercontent.com"
            },
            loginPath: '',
            renderParams: {
                width: 184,
                height: 40,
                longtitle: true
            },
            regEmail: '',
            regPassword: '',
            isBrowser: false,
            appleLoaded: false,
            regFName: '',
            regLName: '',
            countryId: 224,
            isLoading: false,
            checkedTerms: false,
            checked18: false,
            checkedNews: true,
            secureRegPassword: true,
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            rules: {
                required: value => !!value || 'Required.',
                min: value => value.length >= 8 || 'Min 8 characters',
                emailValid: value => this.isEmailValid(value) || 'Invalid email'
            },
            errorMsg: '',
            nextStep: false,
            missingResponseModalFlag: false,
            FB: {},
            fbScope: {},
            localCountries: {
                'AmericanSamoa': 4,
                'Andorra': 5,
                'Armenia': 11,
                'Australia': 13,
                'Austria': 14,
                'Bangladesh': 18,
                'Belarus': 20,
                'Bulgaria': 261,
                'Hungary': 262,
                'Belgium': 21,
                'Brazil': 29,
                'BritishIndianOceanTerritory': 30,
                'BritishVirginIslands': 31,
                'Canada': 39,
                'Chile': 44,
                'China': 45,
                'ChristmasIsland': 46,
                'Colombia': 48,
                'CookIslands': 50,
                'Cyprus': 54,
                'CzechRepublic': 55,
                'Denmark': 57,
                'Ecuador': 61,
                'ElSalvador': 63,
                'Estonia': 66,
                'FaroeIslands': 69,
                'Finland': 71,
                'France': 72,
                'Georgia': 77,
                'Germany': 78,
                'Greece': 81,
                'Greenland': 82,
                'Guam': 84,
                'HolySeeVaticanCity': 90,
                'Hong Kong': 92,
                'India': 95,
                'Indonesia': 96,
                'Ireland': 99,
                'IsleofMan': 100,
                'Israel': 101,
                'Italy': 102,
                'Japan': 105,
                'Jersey': 106,
                'Jordan': 260,
                'Kazakhstan': 108,
                'Kiribati': 110,
                'Kosovo': 111,
                'Kuwait': 112,
                'Kyrgyzstan': 113,
                'Latvia': 115,
                'Liechtenstein': 120,
                'Lithuania': 121,
                'Luxembourg': 122,
                'Malaysia': 127,
                'Malta': 130,
                'MarshallIslands': 131,
                'Mayotte': 134,
                'Mexico': 135,
                'Micronesia': 136,
                'Monaco': 138,
                'Montenegro': 140,
                'Nauru': 145,
                'Netherlands': 147,
                'NewZealand': 150,
                'Nicaragua': 151,
                'Nigeria': 153,
                'Niue': 154,
                'NorfolkIsland': 155,
                'NorthernMarianaIslands': 157,
                'Norway': 158,
                'Pakistan': 160,
                'Palau': 161,
                'Peru': 165,
                'Philippines': 166,
                'PitcairnIslands': 167,
                'Poland': 168,
                'Portugal': 169,
                'PuertoRico': 170,
                'Russia': 174,
                'SaintBarthelemy': 176,
                'SaintMartin': 180,
                'SaintPierreandMiquelon': 181,
                'SanMarino': 184,
                'SaudiArabia': 186,
                'Seychelles': 256,
                'Singapore': 191,
                'Slovakia': 192,
                'Slovenia': 193,
                'SouthAfrica': 196,
                'SouthKorea': 197,
                'Spain': 198,
                'SriLanka': 199,
                'Svalbard': 202,
                'Sweden': 204,
                'Switzerland': 205,
                'Taiwan': 207,
                'Tajikistan': 208,
                'Thailand': 210,
                'TimorLeste': 211,
                'Tokelau': 213,
                'Turkey': 217,
                'TurksandCaicosIslands': 219,
                'Tuvalu': 220,
                'Ukraine': 222,
                'UnitedArabEmirates': 223,
                'UnitedKingdom': 224,
                'UnitedStates': 225,
                'USVirginIslands': 227,
                'Venezuela': 230,
                'Vietnam': 231,
                'Guadeloupe': 238,
                'Martinique': 239,
                'Reunion': 240,
                'FrenchGuiana': 245,
                'Romania': 255,
            }
        };
    },
    methods: {
        getLoginPath() {
            this.loginPath = localStorage.getItem('login_path');
        },
        loginGgl(response) {
            let _loginCtrl = this;

            this.$store.dispatch(AAuth.LOGIN_GOOGLE_USER, {id_token: response.wc.id_token}).then((res) => {
                let token = res.access_token;
                localStorage.setItem('access_token', token);
                _loginCtrl.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                _loginCtrl.$gtm.push({ event: "registration" });
                window.fbq('track', 'CompleteRegistration');
                window.uetq = window.uetq || [];
                window.uetq.push("event", "signup", {});
                _loginCtrl.$gtm.push({
                    'event': 'UETRegistration',
                    'ecomm_pagetype': 'conversion'
                });

                if (_loginCtrl.loginPath && _loginCtrl.loginPath !== '') {
                    localStorage.removeItem('login_path');
                    _loginCtrl.$router.push(this.localePath({path: _loginCtrl.loginPath}));
                } else {
                    _loginCtrl.$router.push(this.localePath({path: 'my-account'}));
                }
            });
        },
        loggedGgl(response) {
            let _loginCtrl = this;

            this.$store.dispatch(AAuth.LOGIN_GOOGLE_USER, {id_token: response.wc.id_token}).then((res) => {
                let token = res.access_token;
                localStorage.setItem('access_token', token);
                _loginCtrl.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                _loginCtrl.$gtm.push({ event: "registration" });
                window.fbq('track', 'CompleteRegistration');
                window.uetq = window.uetq || [];
                window.uetq.push("event", "signup", {});
                _loginCtrl.$gtm.push({
                    'event': 'UETRegistration',
                    'ecomm_pagetype': 'conversion'
                });

                if (_loginCtrl.loginPath && _loginCtrl.loginPath !== '') {
                    localStorage.removeItem('login_path');
                    _loginCtrl.$router.push(this.localePath({path: _loginCtrl.loginPath}));
                } else {
                    _loginCtrl.$router.push(this.localePath({path: 'my-account'}));
                }
            });
        },
        handleSdkInit({FB, scope}) {
            this.FB = FB;
            this.fbScope = scope
        },
        loginFb(response) {
            if (typeof response !== 'undefined' && response.status === "connected") {
                let _loginCtrl = this;

                this.$store.dispatch(AAuth.LOGIN_EXTERNAL_USER, {accessToken: response.authResponse.accessToken}).then((res) => {
                    let token = res.access_token;
                    this.$nuxt.$emit('logged', 'User logged');
                    localStorage.setItem('access_token', token);
                    _loginCtrl.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                    _loginCtrl.$gtm.push({ event: "registration" });
                    window.fbq('track', 'CompleteRegistration');
                    window.uetq = window.uetq || [];
                    window.uetq.push("event", "signup", {});
                    _loginCtrl.$gtm.push({
                        'event': 'UETRegistration',
                        'ecomm_pagetype': 'conversion'
                    });

                    if (_loginCtrl.loginPath && _loginCtrl.loginPath !== '') {
                        localStorage.removeItem('login_path');
                        _loginCtrl.$router.push(this.localePath({path: _loginCtrl.loginPath}));
                    } else {
                        _loginCtrl.$router.push(this.localePath({path: 'my-account'}));
                    }
                });
            } else if (typeof response === 'undefined') {
                let _loginCtrl = this;
                let _token = this.FB.getAccessToken();

                this.$store.dispatch(AAuth.LOGIN_EXTERNAL_USER, {accessToken: _token}).then((res) => {
                    let token = res.access_token;
                    localStorage.setItem('access_token', token);
                    _loginCtrl.$store.commit(MAuth.SET_ACCESS_TOKEN, token);
                    _loginCtrl.$gtm.push({ event: "registration" });
                    window.fbq('track', 'CompleteRegistration');
                    window.uetq = window.uetq || [];
                    window.uetq.push("event", "signup", {});
                    _loginCtrl.$gtm.push({
                        'event': 'UETRegistration',
                        'ecomm_pagetype': 'conversion'
                    });

                    if (_loginCtrl.loginPath && _loginCtrl.loginPath !== '') {
                        localStorage.removeItem('login_path');
                        _loginCtrl.$router.push(this.localePath({path: _loginCtrl.loginPath}));
                    } else {
                        _loginCtrl.$router.push(this.localePath({path: 'my-account'}));
                    }
                });
            }
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        isEmailValid(email) {
            return this.reg.test(email)
        },
        resendMail() {
            this.sendMail(this.regEmail)
        },
        registration() {
            this.$v.regFName.$touch();
            this.$v.regLName.$touch();
            if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                if (this.checkedTerms && this.checked18) {
                    this.isLoading = true;
                    let payload = {
                        email: this.regEmail,
                        password: this.regPassword,
                        confirmPassword: this.regPassword,
                        firstname: this.regFName,
                        lastname: this.regLName,
                        countryId: this.countryId,
                        phoneNumber: '',
                        name: '',
                        enabledNotification: this.enabledNotification === true ? 1 : 0,
                        newsletter: this.checkedNews
                    };
                    this.signup(payload).then(res => {
                        if (res.statusCode === 400) {
                            this.isLoading = false;
                            this.errorMsg = 'Email is already in use.';
                        } else if (res.statusCode === 422) {
                            this.isLoading = false;
                            this.errorMsg = 'Registrations from your country are not allowed.';
                        } else {
                            if (res.reasonPhrase === "Created") {
                                localStorage.setItem('user_email', this.regEmail);
                                this.$gtm.push({ event: "registration" });
                                window.fbq('track', 'CompleteRegistration');
                                this.$gtm.push({ event: "RegistrationPending" });
                                this.$router.push(this.localePath({path: '/registration-pending'}));
                            }
                        }
                    }).catch(err => {
                        this.isLoading = false;

                        if (err.statusCode === 422) {
                            this.isLoading = false;
                            if (err.data && err.data.errors && err.data.errors.Email && err.data.errors.Email[0]) {
                                this.errorMsg = 'Email is already in use.';
                            } else {
                                this.errorMsg = 'Registrations from your country are not allowed.';
                            }
                        } else {
                            if (err.data.errors) {
                                if (err.data.statusCode === 422) {
                                    if (err.data && err.data.errors && err.data.errors.Email && err.data.errors.Email[0]) {
                                        this.errorMsg = 'Email is already in use.';
                                    } else {
                                        this.errorMsg = 'Registrations from your country are not allowed.';
                                    }
                                } else {
                                    if (err.data.errors.Email.length) {
                                        err.data.errors.Email.forEach(err => {
                                            this.errorMsg = err;
                                        })
                                    } else if (err.data.errors.GeneralError.length) {
                                        err.data.errors.GeneralError.forEach(err => {
                                            this.errorMsg = err;
                                        })
                                    } else {
                                        this.errorMsg = 'Unexpected behavior. Please check your internet connection or try again later.';
                                    }
                                }
                            }
                        }
                    })
                } else {
                    this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                }
            } else {
                this.errorMsg = 'Please fill the above information.';
            }
        },
        ...mapActions({
            signup: AAuth.REG_USER,
            sendMail: AAuth.SEND_MAIL,
            loadVisitorCountry: AUser.GET_VISITOR_COUNTRY
        })
    },
    mounted () {
        this.isBrowser = process.browser;
        this.getLoginPath();

        setTimeout(() => {
            this.appleLoaded = true
        }, 1200)

        this.loadVisitorCountry().then(() => {
            if (this.localCountries[this.visitorCountry.replaceAll('-','').replaceAll(' ','').replaceAll('(','').replaceAll(')','')]) {
                this.countryId = parseInt(this.localCountries[this.visitorCountry.replaceAll('-','').replaceAll(' ','').replaceAll('(','').replaceAll(')','')]);
            }
        })
    }
}
</script>

<style scoped>
.social-btns-wrapper {
    text-align: center;
    align-content: center;
    justify-content: center;
}

.social-title {
    text-align: center;
    color: #707070;
}

.social-title span {
    background: #f5f6f5;
    position: relative;
    z-index: 9;
    padding: 0 10px;
}

.social-border {
    height: 1px;
    width: 100%;
    background: #707070;
    position: relative;
    top: -11px;
}

.errors-container2 {
    height: auto;
    width: 100%;
    background: rgba(215, 83, 83, 0.08);
    margin-top: 15px;
}

.errors-container2 p {
    color: #D75353;
    line-height: 32px;
    font-size: var(--fs-small);
    padding-left: 15px;
}

.login-success-btn-wrapper {
    margin-top: 40px;
}

.login-success-btn-wrapper .btn-bid-proceed.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background-color: var(--brand);
    color: #ffffff;
    min-width: 150px;
    margin-right: 15px;
}

.login-success-btn-wrapper .btn-bid-cancel.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}

.login-success {
    text-align: center;
    background: url('../assets/success_icon.png') no-repeat center 30px;
    padding: 140px 32px 0;
}

.login-container {
    text-align: center;
    padding: 0 calc(3 * var(--gutter)) calc(4 * var(--gutter));
}

.logo-img {
    background: url('../assets/v_dark.svg') no-repeat center 50px;
    background-size: contain;
    width: 300px;
    height: 180px;
    margin: 0 auto;
}

h2 {
    color: #707070;
    margin-bottom: calc(2 * var(--gutter));
}

.login-inner-container {
    max-width: 700px;
    background: #F5F6F5;
    border-radius: 10px;
    padding: 30px 50px 50px;
    margin: 0 auto;
    position: relative;
}

.login-label {
    position: absolute;
    font-size: var(--fs-base);
    color: #303030;
    font-weight: 300;
}

.login-container .submit {
    margin-top: 0;
    background: #E1C376 !important;
    color: #FFF !important;
    width: 200px;
    height: 40px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    font-weight: lighter;
    box-shadow: none;
    margin-left: 0;
    margin-right: 0;
}

.footer-links {
    max-width: 700px;
    margin: 20px auto 0;
    display: flex;
}

.footer-link {
    display: inline-block;
    width: 33.33%;
}

.footer-links .terms {
    width: max-content;
    margin: 0 auto;
}

.footer-links .forgot-pass,
.footer-links .create-account {
    width: max-content;
}

.footer-links .create-account {
    float: right;
}

.link-border {
    height: 1px;
    width: 100%;
    background: #707070;
}

.footer-links > div:hover .link-border {
    background: var(--brand);
}

.check-terms {
    margin-top: 0;
}

@media (max-width: 767px) {
    h2 {
        font-weight: 300;
        font-size: 28px;
        line-height: 30px;
    }

    .login-container .submit {
        width: 100%;
    }

    .login-container {
        padding: 0 15px 30px;
    }

    .logo-img {
        background: url('../assets/v_dark.svg') no-repeat center;
        background-size: contain;
        width: 170px;
        height: 80px;
    }

    .login-inner-container {
        padding: 30px 15px;
    }

    .footer-links {
        display: block;
    }

    .footer-link {
        display: block;
        width: 100%;
        text-align: center !important;
    }

    .footer-links .forgot-pass,
    .footer-links .create-account {
        width: 100%;
    }

    .link-border {
        height: 0;
    }

    .footer-links .create-account {
        float: none;
        margin-top: 5px;
    }

    .footer-links .terms {
        margin-top: 5px;
    }
}
</style>

<style>
.v-facebook-login {
    margin: 15px auto;
    width: 240px;
}

.loginpage .header-login-btn,
.loginpage .header-register-btn,
.loginpage .header-container {
    display: none;
}

.login-container .flex {
    margin-top: 20px;
    text-align: left;
}

.login-container .v-input input {
    height: 50px;
    max-height: unset;
    margin-top: 20px;
    padding-left: 15px;
}

.login-container .v-text-field .v-input__append-inner {
    margin-top: 20px;
    background: #fff;
    height: 50px;
}

.login-container .v-text-field .v-input__append-inner .v-input__icon {
    margin-top: 12px;
}

.login-container .v-text-field .v-input__append-inner .primary--text {
    color: #000 !important;
    caret-color: #000 !important;
}

.login-container .theme--light.v-input:not(.v-input--is-disabled) input {
    border: 0;
}

.login-container .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
    border-color: var(--brand);
}

.login-container .theme--light.v-text-field > .v-input__control > .v-input__slot:after {
    border-color: rgba(0, 0, 0, .87);
    border-width: 1px;
}

.login-container .theme--light.v-text-field.error--text > .v-input__control > .v-input__slot:after {
    border-color: #ff5252;
}

.login-container .footer-links a,
.login-container .check-terms a {
    text-decoration: none;
    color: #707070;
    font-size: 19px;
    font-weight: 300;
}

.login-container .footer-links a:hover,
.login-container .check-terms a:hover {
    color: var(--brand);
}

.theme--light.v-application.loginpage {
    background: #ffffff;
}

.login-container .v-input--checkbox .v-messages {
    display: none;
}
</style>
